import React, { useEffect } from 'react';

export function ExternalRedirect({ to }: { to: string }) {
  useEffect(() => {
    if (typeof window !== 'undefined') {
      window.location.replace(to);
    }
  }, [to]);

  return null;
}

export function MarketingRedirect() {
  return <ExternalRedirect to="https://www.meter.com/connect" />;
}
